import { Component, OnInit } from '@angular/core';
import { MemberQuery, PopulationQuery } from '@fgb/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-account-details-page',
  templateUrl: './account-details-page.component.html',
  styleUrls: ['./account-details-page.component.scss'],
})
export class AccountDetailsPageComponent implements OnInit {
  name$: Observable<string>;
  screenType = ScreenType;
  populations = Populations;
  isSuiteOrPts: boolean = false;

  constructor(
    private memberQuery: MemberQuery,
    private populationQuery: PopulationQuery
  ) {}

  ngOnInit() {
    this.name$ = this.memberQuery.selectMemberDetails().pipe(
      map((m) => {
        if (m) {
          return `${m.FirstName} ${m.Surname}`;
        }
        return '';
      })
    );

    this.isSuiteOrPts = this.populationQuery.userInPopulation([this.populations.Suite, this.populations.Pts]);
  }
}
